import React, { useRef, useEffect, useState } from 'react'
import { withGoogleMap, GoogleMap, withScriptjs, OverlayView, Circle } from 'react-google-maps'
import { useTranslation } from 'react-i18next'

import config from '../../../config'
import styles from './styles.module.scss'

import PlaceMarker from '../PlaceMarker'

const getDistance = (lat1, lng1, lat2, lng2) => {
  const R = 6371; // Earth radius in km

  const toRad = (deg) => deg * Math.PI / 180;

  const dLat = toRad(lat2 - lat1);
  const dLng = toRad(lng2 - lng1);

  const a =
    Math.sin(dLat / 2) * Math.sin(dLat / 2) +
    Math.cos(toRad(lat1)) *
    Math.cos(toRad(lat2)) *
    Math.sin(dLng / 2) *
    Math.sin(dLng / 2);

  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));

  return R * c;
}

const getZoomLevel = (distance) => {
  if (distance < 0.1) return 18;
  if (distance < 0.5) return 17;
  if (distance < 1) return 16;
  if (distance < 5) return 15;
  if (distance < 10) return 10;
  if (distance < 50) return 6;
  if (distance < 200) return 5;
  return 5;
}

const Map = withScriptjs(withGoogleMap((props) => {
  return (
    <GoogleMap
      options={{
        // zoomControl: false,
        // mapTypeControl: false,
        // fullscreenControl: false,
        // streetViewControl: false,
        // scaleControl: false,
        // rotateControl: false,
        // keyboardShortcuts: true,
        // draggable: false,
        // scrollwheel: false,
        // disableDoubleClickZoom: true,
        // gestureHandling: 'none',
        // disableDefaultUI: true,
        styles: [
          {
            featureType: 'poi',
            elementType: 'labels',
            stylers: [{ visibility: 'off' }],
          }
        ],
      }}
      {...props}
      handleLoaded={(map) => {
        console.log('map handleLoaded', map)
      }}
      />
  )
}))

const PlacesMap = ({lat, lng, places, highlightedPlaceId, selectedPlace, onChangePlace}) => {
  const containerRef = useRef(null)
  const { i18n } = useTranslation()

  const [height, setHeight] = useState(400)

  useEffect(() => {
    setHeight(containerRef.current.clientHeight-20)
  }, [])

  const handleClickMarker = place => {
    onChangePlace(place)
  }

  return (
    <div ref={containerRef} className={styles.container}>
      <Map
        googleMapURL={`https://maps.googleapis.com/maps/api/js?key=${config.google.key}&v=3.exp&language=${i18n.language}`}
        loadingElement={<div style={{ height: `${height}px` }} />}
        containerElement={<div style={{ height: `${height}px` }} />}
        mapElement={<div style={{ height: `${height}px` }} />}
        center={{lat: lat, lng: lng}}
        zoom={selectedPlace ? 17 : getZoomLevel(getDistance(lat, lng, places[0]?.lat || lat, places[0]?.lng || lng))}>
        {
          places.filter(p => p.radius).map((place) => {
            return (
              <Circle
                key={place.id}
                center={{lat: place.lat, lng: place.lng}}
                radius={place.radius}
                options={{
                  strokeColor: 'rgba(0, 123, 255, 0.5)',
                  strokeOpacity: 1,
                  strokeWeight: 2,
                  fillColor: 'rgba(0, 123, 255, 0.3)',
                  fillOpacity: 1,
                }} />
            )
          })
        }
        {
            places.map((place) => {
              const isHighlighted = highlightedPlaceId === place.id || selectedPlace?.id === place.id
              return (
                <OverlayView 
                  key={place.id}
                  position={{lat: place.lat, lng: place.lng}}
                  mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET}>
                  <PlaceMarker
                    place={place}
                    isSelected={selectedPlace?.id === place.id}
                    isHighlighted={isHighlighted}
                    onClick={handleClickMarker} />
                </OverlayView>
              )
            })
        }
      </Map>
    </div>
  )
}

export default PlacesMap
